import authSdk from '../sdk'

const servicemgmt = authSdk.createAxiosInstance({
    baseURL: import.meta.env.APP_SERVICE_API_V3_URL,
})

export default servicemgmt
